import React from 'react';
import logoGuiaDoPovo from '../../assets/logo_guia_do_povo.png';

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border)] bg-[var(--card)] mt-auto">
      <div className="px-4 sm:px-6 lg:px-8 py-6">
        <div className="mx-auto max-w-[1200px]">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <img 
                src={logoGuiaDoPovo} 
                alt="Guia do Povo" 
                className="h-8 w-auto opacity-80"
              />
              <p className="text-sm text-[var(--muted)]">
                Dados, Política e Notícias para o Cidadão
              </p>
            </div>
            
            <div className="flex items-center gap-6 text-sm text-[var(--muted)]">
              <a 
                href="/sobre" 
                className="hover:text-[var(--accent)] transition-colors"
                aria-label="Sobre o Guia do Povo"
              >
                Sobre
              </a>
              <a 
                href="/contato" 
                className="hover:text-[var(--accent)] transition-colors"
                aria-label="Entre em contato"
              >
                Contato
              </a>
              <a 
                href="/privacidade" 
                className="hover:text-[var(--accent)] transition-colors"
                aria-label="Política de privacidade"
              >
                Privacidade
              </a>
            </div>
          </div>
          
          <div className="mt-4 pt-4 border-t border-[var(--border)] text-center text-xs text-[var(--muted)]">
            <p>© 2025 Guia do Povo. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
